import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ProjectsList from "./components/proj/ProjectsList.jsx";
import "./Styles/proj.css"
export const Projects = () => {
  

  return (
    <div className='bodyconrainer-70001'>
      
      <ProjectsList />

    </div>

  );
};
